if (process.env.NODE_ENV !== 'production') {
    console.log("\n%c Mercury 2.0.0", "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #2563EB, #82a0e2);background-origin: border-box;background-clip: padding-box, border-box;")
}

/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/

import '../styles/main.scss';

/*------------------------------------------------------------------ 
Import scripts
------------------------------------------------------------------*/

import { $, $$ } from '@/utilities/helpers';
import { AnimatedSymbol } from '@/components/animated-symbol';
import initMegaMenu from '@/components/mega-menu';
import initMobileMenu from '@/components/mobile-menu';
import initSubnav from '@/components/subnav';
import '@/components/tracking';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


/*------------------------------------------------------------------
Start the app
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    /*------------------------------------------------------------------
    Mega Menu
    ------------------------------------------------------------------*/

    initMegaMenu();
    initMobileMenu();
    initSubnav();

    const createScrollAnimation = (animationTarget, trigger, fromVars, toVars = {}) => {
        gsap.timeline({
            scrollTrigger: {
                trigger,
                start: 'top 95%',
                end: 'bottom 90%',
                scrub: 0
            }
        }).fromTo(animationTarget, fromVars, {
            y: 0,
            x: 0,
            scale: 1,
            opacity: 1,
            ...toVars
        });
    };


    $$('.js-slide-in-left').forEach((element) => {
        createScrollAnimation(element, element,
            { y: 0, x: -50, scale: 0.95, opacity: 0 }
        );
    });


    $$('.js-slide-in-right').forEach((element) => {
        createScrollAnimation(element, element,
            { y: 0, x: 50, scale: 0.95, opacity: 0 }
        );
    });


    const animatedSymbol = new AnimatedSymbol(document.querySelector('.footer'));

    if ($('.js-noir-banner')) {

        const animatedSymbol = new AnimatedSymbol(document.querySelector('.js-noir-banner'));
    }


    /*------------------------------------------------------------------
    Hero parallax effect
    ------------------------------------------------------------------*/
    const hero = document.querySelector('.hero-element');
    const heroBg = hero?.querySelector('.hero-element__background');
    if (heroBg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let ticking = false;
        const updateParallax = () => {
            const rect = hero.getBoundingClientRect();
            const vh = window.innerHeight;
            if (rect.bottom > 0 && rect.top < vh) {
                // progress: 1 when top at viewport bottom → 0 when top at viewport top
                // produces a gentle 40px shift across the full scroll range
                const progress = rect.top / vh;
                heroBg.style.transform = `translateY(${progress * 80}px)`;
            }
            ticking = false;
        };
        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateParallax);
                ticking = true;
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        updateParallax();
    }

    /*------------------------------------------------------------------
    Intersection observers for animation styles
    ------------------------------------------------------------------*/

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
            }
        });
    }, {
        root: null, // Use the viewport as the root
        rootMargin: '-5% 0px' // Trigger when the element is in the middle of the page
    });

    // Add the observer to all elements with the class `js-inview`
    setTimeout(() => $$('.js-inview').forEach(element => observer.observe(element)), 10);


    /*------------------------------------------------------------------
    Sliders
    ------------------------------------------------------------------*/

    if ($('.embla')) {
        import('@/components/slider')
            .then(module => $$('.embla').forEach(element => new module.Slider(element)))
            .catch(error => console.error("Slider video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Banner Video
    ------------------------------------------------------------------*/

    if ($('.js-banner-video')) {
        import('@/components/banner-video')
            .catch(error => console.error("Banner video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Accordion Elements
    ------------------------------------------------------------------*/

    if ($('.js-accordion-element')) {
        import('@/components/accordion')
            .then(module => $$('.js-accordion-element').forEach(element => new module.Accordion(element)))
            .catch(error => console.error("Accordion component failed to load", error));
    }


    /*------------------------------------------------------------------
    Instant Search Page
    ------------------------------------------------------------------*/

    if ($('.instant-search')) {
        import('@/pages/instant-search')
            .then(module => module.default())
            .catch(error => console.error('Instant search failed to load', error));
    }


    /*------------------------------------------------------------------
    Newsletter Form
    ------------------------------------------------------------------*/

    if ($('.js-newsletter-form')) {
        import('@/components/newsletter-form')
            .then(module => $$('.js-newsletter-form').forEach(el => module.initNewsletterForm(el)))
            .catch(error => console.error('Newsletter form component failed to load', error));
    }


    /*------------------------------------------------------------------
    Video Elements
    ------------------------------------------------------------------*/

    if ($('.js-video-element')) {
        import('@/components/video')
            .then(module => $$('.js-video-element').forEach(element => new module.Video(element)))
            .catch(error => console.error("Video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Footer reveal parallax:
    The footer-reveal is fixed at the bottom. Body padding-bottom gives
    enough scroll room to expose it. As you scroll into that zone, it
    rises from 50% off-screen to fully visible.
    ------------------------------------------------------------------*/

    const footerReveal = document.querySelector('.footer-reveal');
    if (footerReveal) {
        let revealHeight = 0;

        const setDimensions = () => {
            revealHeight = footerReveal.offsetHeight;
            document.body.style.paddingBottom = revealHeight + 'px';
        };

        const parallax = () => {
            const totalScrollable = document.documentElement.scrollHeight - window.innerHeight;
            const revealStart = totalScrollable - revealHeight;
            const progress = Math.max(0, Math.min(1,
                (window.scrollY - revealStart) / revealHeight
            ));
            const scale = 0.96 + 0.04 * progress;
            footerReveal.style.transform = `scale(${scale}) translateY(${(1 - progress) * 50}%)`;
            footerReveal.style.opacity = 0.2 + 0.8 * progress;
        };

        setDimensions();
        parallax();

        window.addEventListener('scroll', parallax, { passive: true });
        window.addEventListener('resize', () => { setDimensions(); parallax(); });

        setTimeout(() => {
            setDimensions();
            parallax();
        }, 100);
    }



    /*------------------------------------------------------------------
    Post Load classname removal:
    This removes the class `js-postload` from elements after the page 
    has loaded, to prevent any unwanted animations.
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });

    /*------------------------------------------------------------------
    #uff anchor scroll:
    If the URL contains #uff, scroll to the userform text element.
    ------------------------------------------------------------------*/

    if (window.location.hash === '#uff') {
        const userform = document.querySelector('.text-element--userform');
        if (userform) {
            userform.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }


    /*------------------------------------------------------------------
    Sticky header:
    It hides/shows the header when scrolling up and down
    ------------------------------------------------------------------*/

    // Initialize the previous scroll position to 0
    let previousScrollPosition = 0;

    // Define the scroll delta to determine significant scroll changes
    const scrollDelta = 5;

    // Select the header element
    const header = document.querySelector('.header');

    // Calculate the header height, defaulting to 0 if the header is not found
    const headerHeight = header ? header.clientHeight : 0;

    /**
     * Function to handle the sticky header behavior based on scroll position.
     */
    const stickyHeader = () => {
        // If no header is found, exit the function
        if (!header) return;

        // Get the current scroll position
        let currentScroll = window.scrollY;

        // If the scroll change is less than the defined delta, exit the function
        if (Math.abs(previousScrollPosition - currentScroll) <= scrollDelta) return;

        // If at the top of the page, remove any navigation classes
        if (currentScroll < 30) {
            header.classList.remove('nav-down', 'nav-up');
        }
        // If scrolling down and past the header height, hide the header
        else if (currentScroll > previousScrollPosition && currentScroll > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        }
        // If scrolling up and not at the bottom of the page, show the header
        else {
            if (currentScroll + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }

        // Update the previous scroll position
        previousScrollPosition = currentScroll;

    };

    // Use requestAnimationFrame for smoother scroll event handling
    let isScrolling = false;

    // Add a scroll event listener to the window
    window.addEventListener('scroll', () => {
        // If not already scrolling, use requestAnimationFrame to call stickyHeader
        if (!isScrolling) {

            window.requestAnimationFrame(() => {
                stickyHeader();
                isScrolling = false;
            });

            isScrolling = true;
        }
    });

    stickyHeader();
});

